import Svg, {
  type PathProps,
  type SvgProps,
  Text as SvgText,
} from 'react-native-svg'

import {usePalette} from '#/lib/hooks/usePalette'

const ratio = 24 / 120

export function Logotype({
  fill,
  ...rest
}: {fill?: PathProps['fill']} & SvgProps) {
  const pal = usePalette('default')

  const size =
    typeof rest.width === 'number'
      ? rest.width
      : parseInt(String(rest.width || 120), 10) || 120

  return (
    <Svg
      viewBox="0 0 120 24"
      {...rest}
      width={size}
      height={Number(size) * ratio}>
      <SvgText
        x="0"
        y="19"
        fontSize="23"
        fontWeight="700"
        fill={fill || pal.text.color}>
        GroovyVerse
      </SvgText>
    </Svg>
  )
}
